import { h } from 'preact';
import util from 'preact-util';

import DateTile from './dateTile';

/**
 * Card for a single point in time: the Apple-style DateTile on the left, a
 * small label and the HH:MM time on the right, plus an optional muted postfix
 * line (used for the race-local time when the race runs in another timezone
 * than the viewer). Replaces GuiInfoBox for «Løpsstart» / «Påmeldingsstart»
 * on the race detail page. Renders nothing without a valid date.
 */
function DateTileCard({ stores, label, date, postfix, isCancelled = false, classesContainer = '' }) {
    if (!date || Number.isNaN(new Date(date).getTime())) {
        return null;
    }
    const { userStore = {} } = stores || {};
    const { user = {} } = userStore;
    const darkmode = util.getNestedValue(user, 'settings.darkmode');
    const time = util.formatDate(date, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' }, true);

    return (
        <div class={`d-flex flex-column mx-1 my-1 ${classesContainer}`}>
            <div
                class={`box-container d-flex flex-row align-items-center py-2 px-3 ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}
                style='line-height: 1.25em;'
            >
                <DateTile date={date} isCancelled={isCancelled} />
                <div class='d-flex flex-column ms-3 overflow-hidden'>
                    <small class='font-weight-light text-body-secondary'>{label}</small>
                    <span class={isCancelled ? 'text-body-tertiary' : ''} style='font-size: 1.5em;'>{time}</span>
                    {postfix && (
                        <small class='text-body-secondary' style='opacity: 0.7;'>{postfix}</small>
                    )}
                </div>
            </div>
        </div>
    );
}

export default DateTileCard;
